(function(){
    'use strict';

    angular.module('elogbooks.user.finance.sales-invoices', []);
})();
